export default [
  {
    id: 1,
    model: '01-exquisita.fbx',
    name: '1. Exquisita',
    nameEn: '1. Exquisita',
    template: '01-exquisita.png',
    download: '01-exquisita.png',
    objectName: '01_obj_falafel_1',
    planeName: '01_plane_falafel_1',
    separation: 4,
    cameraData: [0, 0.6, 0.2, 1.773 * 1.5, 1.2 * 2, 1.99 * 2],
  },
  {
    id: 2,
    model: '02-tostitos.fbx',
    name: '2. Tostitos',
    nameEn: '2. Tostitos',
    template: '02-tostitos.png',
    download: '02-tostitos.png',
    objectName: '01_obj_pan_1',
    planeName: '01_plane_pan_1',
    separation: 3,
    cameraData: [0, 0.6, 0, 1.773 * 1.5, 1.2 * 2, 1.99 * 2],
  },
  {
    id: 3,
    model: '03-fideos.fbx',
    name: '3. Fideos',
    nameEn: '3. Fideos',
    template: '03-fideos.png',
    download: '03-fideos.png',
    objectName: '01_obj_fideos',
    planeName: '01_plane_fideos',
    separation: 1.5,
    cameraData: [0, 0.5, 0, 1.773 * 1.5, 1.2 * 1.5, 1.99 * 1.5],
  },
];
